import React, { FC, useMemo, useContext, useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { DealResponseCodes } from '../../../../../common/enum/DealResponseCodes';
import { PostCodeContext } from '../../../../../common/react/PostCodeContext';
import { stickyError } from '../../../../service/stickyError';
import currentDealSelectors from '../../../../store/selectors/currentDealSelectors';
import stickyErrorContainerStyles from './stickyErrorContainerStyles';
import Translation from '../../../../../common/components/translation/Translation';

const StickyErrorContainer: FC = () => {
  const styles = stickyErrorContainerStyles();
  const dealError = useSelector(currentDealSelectors.getErrorStatus);
  const { enableRefresh } = useContext(PostCodeContext);

  const errorMessage: string | null = useMemo(() => {
    return stickyError.generateStickyErrorMessage(dealError);
  }, [dealError]);

  useEffect(() => {
    if (dealError?.response?.data?.code === DealResponseCodes.DEALER_NOT_FOUND) {
      enableRefresh();
    }
  }, [dealError]);

  if (!errorMessage) {
    return null;
  }

  return (
    <Box className={styles.errorContainer}>
      <Typography data-test={'text:sticky_error'}>
        <Translation id={errorMessage} />
      </Typography>
    </Box>
  );
};

export default StickyErrorContainer;
